import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main.vue'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    meta: { moduleName, breadcrumbKey: 'ai', nonLinked: true },
    children: [
      {
        path: 'ai-models',
        name: `${routeNamePrefix}.ai-models`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "ai-management" */ './views/ai-models/list.vue'
            )
          ),
        meta: {
          breadcrumbKey(_, __, pluralTranslator) {
            return `${pluralTranslator('ai_model', 2)}`
          },
        },
      },
      {
        path: 'ai-models/create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "ai-management" */ './views/ai-models/create.vue'
            )
          ),
      },
      {
        path: 'ai-models/edit/:id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "ai-management" */ './views/ai-models/edit.vue'
            )
          ),
        meta: {
          breadcrumbKey: 'edit_ai_model',
        },
      },
      {
        path: 'ai-similarity',
        name: `${routeNamePrefix}.ai-similarity`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "ai-management" */ './views/ai-similarity/similarity-config.vue'
            )
          ),
        meta: {
          breadcrumbKey: 'ai_similarity',
        },
      },
    ],
  },
]
